import { gql } from 'graphql.macro';

export const getPatientOrdersTemplate = gql`
    query patientOrders($personalIdentityNumber: SearchString!) {
        patientOrders(personalIdentityNumber: $personalIdentityNumber) {
            _id
            patient {
                personalIdentityNumber
                firstName
                lastName
                category
            }
            orderIds {
                id
                orderId
            }
            orderCount
        }
    }
`;

export const getPatientOrdersListTemplate = gql`
    query patientOrdersList($searchText: SearchString!, $limit: Int!, $offset: Int!) {
        patientOrdersList(searchText: $searchText, limit: $limit, offset: $offset) {
            _id
            patient {
                personalIdentityNumber
                firstName
                lastName
                category
            }
            orderCount
        }
    }
`;

export const getPatientOrdersByMatBatchNumTemplate = gql`
    query patientOrdersByMatBatchNum($searchText: SearchString!, $limit: Int!, $offset: Int!) {
        patientOrdersByMatBatchNum(searchText: $searchText, limit: $limit, offset: $offset) {
            _id
            patient {
                personalIdentityNumber
                firstName
                lastName
                category
            }
            orderCount
        }
    }
`;
